import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/home/staff.png'
import _imports_1 from '@/assets/close.png'


const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "box row align-start" }
const _hoisted_3 = { class: "box-operate row-flex-one" }
const _hoisted_4 = { class: "list-box" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "list-i row"
}
const _hoisted_7 = { class: "align-items" }
const _hoisted_8 = { class: "name color-black font-base power" }
const _hoisted_9 = {
  key: 0,
  class: "power color-grey font-base"
}
const _hoisted_10 = { class: "power color-grey font-base" }
const _hoisted_11 = { class: "box-selected row-flex-one" }
const _hoisted_12 = { class: "head" }
const _hoisted_13 = { class: "color-grey font-mini" }
const _hoisted_14 = {
  key: 0,
  class: "tab-list align-items"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "list-box"
}
const _hoisted_17 = { class: "align-items" }
const _hoisted_18 = { class: "name color-black font-base power" }
const _hoisted_19 = {
  key: 0,
  class: "power color-grey font-base"
}
const _hoisted_20 = { class: "power color-grey font-base" }
const _hoisted_21 = { class: "foot-btn row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isCloseType ? '' : _ctx.close()))
  }, [
    _createElementVNode("div", {
      class: "container-c",
      style: _normalizeStyle({ width: _ctx.width }),
      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.dataTitle), 1),
      _createElementVNode("div", {
        class: "close point",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, "×"),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.tabsIndex,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabsIndex) = $event)),
            class: "demo-tabs"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "团队成员",
                name: "0"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.tabsIndex === '0')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchInput,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchInput) = $event)),
                    onInput: _ctx.onSearchInput,
                    placeholder: "搜索成员"
                  }, null, 8, ["modelValue", "onInput"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamList, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (!_ctx.searchInput || _ctx.arr.has(item))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _cache[6] || (_cache[6] = _createElementVNode("img", {
                                class: "avatar",
                                src: _imports_0,
                                alt: ""
                              }, null, -1)),
                              _createElementVNode("div", _hoisted_8, _toDisplayString(item.userName), 1),
                              (item.isAdmin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "管理员"))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_10, _toDisplayString(item.position), 1)
                            ]),
                            _createVNode(_component_el_checkbox, {
                              modelValue: item.isSelect,
                              "onUpdate:modelValue": ($event: any) => ((item.isSelect) = $event),
                              size: "large",
                              onChange: ($event: any) => (_ctx.onSelected(item))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "color-black font-base font-weight" }, "已选 ", -1)),
            _createElementVNode("span", _hoisted_13, " (" + _toDisplayString(_ctx.tabsIndex === '0' ? _ctx.selectedLength : '1') + "名成员)", 1)
          ]),
          (_ctx.selectType !== 'one' && _ctx.tabsIndex === '0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ordinarySelectedList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "tab-i color-blue font-base align-items justify-center",
                    key: index
                  }, [
                    _createElementVNode("div", null, _toDisplayString(item.userName), 1),
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "close-img",
                      alt: "",
                      onClick: ($event: any) => (_ctx.onSelected(item))
                    }, null, 8, _hoisted_15)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.tabsIndex === '0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ordinarySelectedList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "list-i row",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[8] || (_cache[8] = _createElementVNode("img", {
                        class: "avatar",
                        src: _imports_0,
                        alt: ""
                      }, null, -1)),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.userName), 1),
                      (item.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "管理员"))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.position), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _cache[11] || (_cache[11] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close()))
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: _ctx.onDetermine
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("确定")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ], 4)
  ]))
}